module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {



var routeNames = [];

_.each([this.reservation.legs, this.selectedFlight.legs], function(legs) {
	var first = _.first(legs[0].segments);
	var last = _.last(legs[legs.length - 1].segments);
	var name = '';

    if (first.departureCity && first.departureCity.caption) {
        name += first.departureCity.caption;
    }
    name += ' - ';
    if (last.arrivalCity && last.arrivalCity.caption) {
        name += last.arrivalCity.caption;
    }
    name += ' | ' + new Time(first.departureDate).format('DD.MM.YY');

	routeNames.push(name);
});
;
__p += '\n\n<div class="b-exchange">\n    <div class="b-exchange__modal">\n        <div class="b-exchange__header">' +
((__t = ( L10N.get('pages.exchange.exchangeConfirmation') )) == null ? '' : __t) +
'</div>\n        <div class="b-exchange__content">\n            ';
 _.each(this.reservation.services, function (service) { ;
__p += '\n                <div class="b-exchange__traveller-service">\n                    <span class="b-exchange__traveller-service__ticketNumber">' +
((__t = ( service.ticketNumber )) == null ? '' : __t) +
'</span>\n                    <span class="b-exchange__traveller-service__fullName">\n                        ' +
((__t = ( _.map(service.travellers, function(t) { return t.fullName }).join(' | ') )) == null ? '' : __t) +
'\n                    </span>\n                </div>\n            ';
 }) ;
__p += '\n\n            ';
 _.each([this.reservation.legs, this.selectedFlight.legs], function(legs, itemIndex) { ;
__p += '\n                        <div class="b-exchange__route-title ' +
((__t = ( itemIndex === 0 ? 'b-exchange__original-route-title' : 'b-exchange__new-route-title')) == null ? '' : __t) +
'">\n                            ' +
((__t = ( itemIndex === 0 ? L10N.get('pages.exchange.originalRoute') : L10N.get('pages.exchange.newRoute') )) == null ? '' : __t) +
'\n                        </div>\n                        <div class="' +
((__t = ( itemIndex === 0 ? 'b-exchange__original-route' : 'b-exchange__new-route' )) == null ? '' : __t) +
' b-exchange__flight">\n                            <div class="b-exchange__flight-header">' +
((__t = ( routeNames[itemIndex] )) == null ? '' : __t) +
'</div>\n                            <div class="b-exchange__flight-legs">\n                                ' +
((__t = ( require('../../pages/b-cabinet/b-cabinet-orders/b-cabinet-order/b-cabinet-order-refund-exchange/refund-exchange-flight-legs.ejs')({legs: legs}))) == null ? '' : __t) +
'\n                            </div>\n                        </div>\n                ';
 }) ;
__p += '\n            <div class="b-exchange__footer">\n                ';

                var sumPrice = this.selectedFlight.price.passengerPrices.reduce((result, price) => {
                  _.each(['feeAndTaxes', 'tariff'], function(key) {
                    var value = price[key];
                    if (value) {
                      if (!result[key]) {
                        result[key] = { amount: 0, currencyCode: value.currencyCode };
                      }
                      result[key].amount += parseFloat(value.amount, 10) * price.passengerCount;
                    }
                  });
                  result.total.currencyCode = price.total.currencyCode;
                  result.total.amount += parseFloat(price.total.amount, 10);
                  return result;
                }, {
                  total: {
                    amount: 0
                  }
                });
                var price = sumPrice;
                ;
__p += '\n                <div class="b-exchange__exchange-warning">\n                    ' +
((__t = ( L10N.get('pages.exchange.exchangeRules') )) == null ? '' : __t) +
'\n                </div>\n                <div class="b-exchange__price-details">\n                    ';
 _.each(['feeAndTaxes', 'tariff'], function(key) { ;
__p += '\n                    ';
 var value = price[key]; ;
__p += '\n                        ';
 if (value) { ;
__p += '\n                            <div class="b-exchange__price-details-row">\n                                <div class="b-exchange__price-details-title">' +
((__t = ( L10N.get('pages.avia.' + key + 'Exchange') )) == null ? '' : __t) +
'</div>\n                                <div class="b-exchange__price-details-price">' +
((__t = ( Formatter.formatMoney(value.amount.toString(), Formatter.getDecimal(value.amount.toString())) )) == null ? '' : __t) +
' ' +
((__t = ( Formatter.formatCurrency(value.currencyCode) )) == null ? '' : __t) +
'</div>\n                            </div>\n                        ';
 } ;
__p += '\n                    ';
 }) ;
__p += '\n                </div>\n                <div class="b-exchange__price-details-row b-exchange__total-price">\n                    <div class="b-exchange__price-details-title">' +
((__t = ( L10N.get('pages.exchange.exchangeTotal') )) == null ? '' : __t) +
'</div>\n                    <div class="b-exchange__price-details-price">' +
((__t = ( Formatter.formatMoney(price.total.amount.toString(), Formatter.getDecimal(price.total.amount.toString())) )) == null ? '' : __t) +
' ' +
((__t = ( Formatter.formatCurrency(price.total.currencyCode) )) == null ? '' : __t) +
'</div>\n                </div>\n            </div>\n        </div>\n        <div class="b-exchange__modal-buttons">\n            <button class="b-exchange__cancel js-cancel">' +
((__t = ( L10N.get('cabinet.orders.cancel') )) == null ? '' : __t) +
'</button>\n            <button class="b-exchange__confirm js-exchange">' +
((__t = ( L10N.get('pages.exchange.confirmExchange') )) == null ? '' : __t) +
'</button>\n        </div>\n    </div>\n</div>\n';

}
return __p
}